import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import msgStyles from '../styles/research/msg.module.css';

export function Msg({ title, text, danger }) {
    const [timeLeft, setTimeLeft] = useState(5); // Contagem regressiva em segundos
    const [referrer, setReferrer] = useState(document.referrer); // Captura a URL anterior
    const style = danger ? { color: '#f03e3e' } : {};

    useEffect(() => {
        document.body.style.backgroundColor = '#303030';
        document.title = title || 'Erro!';

        const interval = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        const timeout = setTimeout(() => {
            // Redireciona para a URL anterior se existir, senão vai para a home
            if (referrer) {
                window.location.href = referrer;
            } else {
                window.location.href = '/';
            }
        }, 5000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [referrer, title]);

    return (
                <div className={msgStyles.container}>
                    <div className={msgStyles.content}>
                        <h1 className={msgStyles.title} style={style}>{title}</h1>
                        <p className={msgStyles.text}>{text}</p>

                        <div className={msgStyles.progressSection}>
                            <p className={msgStyles.countdown}>
                                Você será redirecionado para o formulário em {timeLeft} segundo{timeLeft === 1 ? '' : 's'}...
                            </p>
                            <div className={msgStyles.progressBarContainer}>
                                <div className={msgStyles.progressBar}></div>
                            </div>
                        </div>
                    </div>
                </div>
            );

}